const getEnv = (name) => {
  const env = window?.ENV || {}

  if (Object.hasOwnProperty.call(env, name)) {
    return env[name]
  }

  if (Object.hasOwnProperty.call(process.env, name)) {
    return process.env[name]
  }
}

export default getEnv
